import Profile from 'components/global/Profile';

const VCProfile = () => (<Profile />);

export default VCProfile;
